export default __webpack_public_path__ + "static/media/CovidTrackerCountryPage.6584344d.PNG";